module.exports = __webpack_public_path__ + "img/daichao1.a4ffb6f7.png";